<template lang="html">
  <div id="logo" class="logo">
    <div class="gng gng-1">
      <div class="gng-go">GO</div>
      <div class="gng-nogo">NOGO</div>
    </div>
  </div>
</template>

<script>
// import {contents} from '@/common/content.js'
import gsap from 'gsap'

export default {

  data () {
    return {
      isFinished: false,
      timeline: null
    }
  },

  mounted () {
    // this.intro_D()
  },

  methods: {

    intro_D () {
      let tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 1
      })
      this.timeline = tl

      const elem_nogo = '.gng-nogo'
      const elem_go = '.gng-go'

      tl.set(elem_nogo, { autoAlpha: 0, delay: 0 })
      tl.set(elem_go, { autoAlpha: 1 })

      tl.set(elem_nogo, { autoAlpha: 1, delay: 1 })
      tl.set(elem_go, { autoAlpha: 0 })

    }
  }
}
</script>

<style lang="scss" scoped>
.gng {
  @apply text-red-700 text-center w-auto mx-4 leading-none mb-24;
  font-size: 30vw;
  @screen md {
    @apply flex mb-0;
    font-size: 35vh;
  }
}
</style>
